import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "dollar",
})
export class DollarPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    if (value != null) return "$" + value;
    else return value;
  }
}
